import { Box, Icon, Input, InputGroup } from '@chakra-ui/react';
import { useEffect, useRef, useState } from 'react';
import { LuSearch } from 'react-icons/lu';

const SearchInput = ({ onChange }: { onChange: (value: string) => void }) => {
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  const [search, setSearch] = useState('');

  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearch(e.target.value);
  };

  useEffect(() => {
    timerRef.current = setTimeout(() => onChange(search), 500);

    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
    };
  }, [search]);

  return (
    <InputGroup
      startElement={(
        <Box
          pl={4}
        >
          <Icon as={LuSearch} color="blackAlpha.0" />
        </Box>
      )}
    >
      <Input
        placeholder="Search"
        border="1px solid"
        borderColor="gray.200"
        px={4}
        py={2.5}
        fontSize={16}
        maxWidth={410}
        value={search}
        onChange={handleSearch}
      />
    </InputGroup>
  );
};

export default SearchInput;